import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import CustomSelect from "../../../../helpers/ui/CustomSelect"
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            employeeOptions: [],
            selectedEmployee: null,
            isLoadingOptEmployee: true,
            polaKerjaOptions: [],
            selectedPolaKerja: null,
            isLoadingOptPolaKerja: true
        }
    }

    reformatOptionsEmployee = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
        //   newObj["label"] = data['employee_nip'] +' - '+ data[label];
          newObj["label"] = data[label];
          newObj["value"] = data[value];
          newObj["model"] = data;
      
          return newObj;
        });
    };

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
          newObj["model"] = data;
      
          return newObj;
        });
    };

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })       

        this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            employeeOptions: this.reformatOptionsEmployee(
                                response.result,
                                'employee_current_position_name',
                                'employee_uuid',
                            ),
                            isLoadingOptEmployee: false
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.polaKerjaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            polaKerjaOptions: this.reformatOptions(
                                response.result,
                                'working_pattern_name',
                                'working_pattern_uuid',
                            ),
                            isLoadingOptPolaKerja: false
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.fetchEmployee()
        this.createBloc.fetchPolaKerja()
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.employeeChannel?.unsubscribe()
        this.createBloc.polaKerjaChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Tambah Mapping Pejabat Penetap</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="presensi_exclude_absen_employee_uuid"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name={`presensi_exclude_absen_employee_uuid`}
                                                    errorMessage="Pilih Pegawai"
                                                    options={this.state.employeeOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pegawai"
                                                    isLoading={this.state.isLoadingOptEmployee}
                                                    onChange={
                                                        (v) => this.setState({
                                                            selectedEmployee: v.model
                                                        })
                                                    }
                                                    // defaultValue={data.type}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="signatories_official_nip"
                                                    id="signatories_official_nip"
                                                    // readonly="readonly"
                                                    validate={{ required: { value: true } }}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.selectedEmployee?.employee_nip}
                                                />
                                                <AvField
                                                    placeholder=""
                                                    name="signatories_official_position"
                                                    id="signatories_official_position"
                                                    type="hidden"
                                                    value={this.state.selectedEmployee?.employee_current_position_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Pejabat Penetap<span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="signatories_official_name"
                                                    id="signatories_official_name"
                                                    // readonly="readonly"
                                                    validate={{ required: { value: true } }}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.selectedEmployee?.employee_full_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/pejabat_penetap.html?'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView